import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { visitType, apptFlowType } from '@type';
import { TranslatePipe } from '../pipes/translate.pipe';
import { FeatureFlagsService } from '../services/feature-flags.service';
import { ToastServiceService } from '../services/toast-service.service';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { TOAST_ERROR } from '@string';
import * as _ from 'lodash';
import { DEFAULT_DATE_FORMAT, HOSPITAL, VIDEO } from '@const';
import { PackageService } from '../services/package.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-health-package-slot',
  templateUrl: './health-package-slot.component.html',
  styleUrls: ['./health-package-slot.component.scss'],
  providers: [TranslatePipe]
})
export class HealthPackageSlotComponent implements OnInit  {
  @Input() _input: any;
  @Input() isStandalone: boolean = false;
  @Output() complete: EventEmitter<any>;
  @Output() action: EventEmitter<any>;
  @Input() visitType: visitType;
  @ViewChild('vaadinDp') dateRange: ElementRef;
  public slotList: any;
  public availDateList: any;
  public availDays: any;
  public facilityId: string;
  public specialityId: string;
  public practitionerId: string;
  public searchkey: string;
  public translateType = 'LOCALE';
  public startIndex: number;
  public endIndex: number;
  public _startIndex: number;
  public _endIndex: number;
  public selectedClinicIndex: number;
  public selectedClinic: string;
  public curDate: string;
  public selectedFacility: any;
  public availDaysBrief;
  public availableDays = [];
  public hideFacilityList: boolean;
  public directoffset: number = 0;
  private toRestrictDays: Array<any> = [];
  private allowOnlyDays: Array<any> = null;
  public linkWithoutRelation: boolean = false;
  public selectedDate: any = '';
  public selectedSlot: any = {};
  public selectedSlots: any = [];
  public consultAgainVideoAppt: boolean = false;
  public dir: any;
  public noslot:any ;
  public facilityContactno:any;
  public dates=new Array();
  public date:any;
  public chosenFacility: any;
  public selectedPatient: any;
  public packageOnlyFlow: any;
  public selectedDirective: any;
  public selectedPackage: any;
  public selectedFacilityId: any;
  public isReschedule: any;
  public rescheduleParams: any;
  public selectedVisitType: any;
  public packageIndicator: any;
  public subServicesForAppointmentBooking: any;
  public isBookingSubService: any;
  public consultationSelections: any;
  public careElementParams: any;
  public packageDefination: any;
  public flowType: any;
  public selectedServices: any;
  public selectionsForPromo: any;
  public canPay: boolean = false;
  public choosenFacility: any;
  public healthPkg: any;
  public chargeVatInfo: any;
  public chargeVatDetails: any;
  public chargeDetails: any;
  public packageConfirmView: boolean = false;
  public pointsType: any;
  public isPayableService: boolean = false;
  public patientPayableApprox: any = 0;
  public bookingForConcepts: any;
  public bookingApplicableFacilities: any;
  public slotEvent: any;
  public couponAdditionalParams: any;
  private firstService: any
  private selectedPractitioner: any;
  public openConsultationTypeSelection: boolean = false;
  public selections: any;
  private consultResolve!: (value: string | null) => void;
  public homeCareAddlCharge: any;
  public computedDetail: any = {};
  public apptDetail: any = {};
  constructor(private user: UserService, private translatePipe: TranslatePipe, private featureService: FeatureFlagsService, private toast: ToastServiceService, private packageService: PackageService,  private cdf: ChangeDetectorRef,) {
    this.dir = this.user.getAppDirection()
    this.complete = new EventEmitter<any>();
    this.action = new EventEmitter<any>();
    this.slotList = {
      dates: [],
      clinics: [],
      slots:{}
    };
    this.availDateList = [];
    this.searchkey = '';
    this.availDays = [];
    this.startIndex = 0;
    this._startIndex = 0;
    this.endIndex = 3;
    this._endIndex = 6;
    this.curDate = this.user.getMoment().format('YYYY-MM-DD HH:mm');
  }
  ngOnInit(){
    this.healthPkg = this.packageService.getAllHpValues();
    console.log('healthPkg', this.healthPkg);
    let date = moment().format(DEFAULT_DATE_FORMAT)
    let availDays = this.getAvailDaysList(date);
    this.chosenFacility = this.healthPkg?.choosenFacility;
    this.selectedPatient =  this.healthPkg?.selectedPatient;
    this.flowType = this.healthPkg?.flowType;
    this.packageOnlyFlow = false; //this.controls?.['packageOnlyFlow']
    this.selectedDirective = this.healthPkg?.selectedDirective;
    this.selectedPackage = this.healthPkg?.selectedPackage;
    this.bookingForConcepts = this.healthPkg?.bookingForConcepts;
    this.bookingApplicableFacilities = this.healthPkg?.bookingApplicableFacilities;
    this.selectedFacilityId = this.healthPkg?.choosenFacility?.facilityId;
    this.isReschedule = this.healthPkg?.reschedule;
    this.rescheduleParams = this.healthPkg?.toReschedule
    this.selectedVisitType = this.healthPkg?.selectedVisitType;
    this.packageIndicator = this.healthPkg?.packageIndicator
    this.subServicesForAppointmentBooking = this.healthPkg?.subServicesForAppointmentBooking
    this.isBookingSubService = this.healthPkg?.isBookingSubService || false
    this.consultationSelections = this.healthPkg?.consultationSelections;
    this.selectedPractitioner = this.healthPkg?.selectedPract;
    this.careElementParams = this.healthPkg?.careElementParams
    this.packageDefination = this.healthPkg?.packageDefination
    let facDetail = this.user.findFacility(this.selectedFacilityId)
    let linkedPat = this.user.findLinkedPatient(this.selectedPatient?.uhid);
    this.selectedPatient = {
      ...linkedPat,
      ...this.selectedPatient
    }
    this.getPageConfiguration();
    // console.log('selectedPatient', this.selectedPatient, this.choosenFacility);
    if (facDetail && facDetail.directory && facDetail.directory[0]) {
        this.facilityContactno = facDetail.directory[0].number;
    }
    if(this.healthPkg?.consultationType === VIDEO){
      this.processSlotList(availDays, this.selectedPractitioner?.facList[0]?.facilityId);
    } else
    this.processSlotList(availDays, this.selectedFacilityId);
    this.selectedServices = [
      {
        directiveCode: this.selectedDirective?.['code'] || 'HLTHPKGS',
        conceptCode: this.selectedPackage?.['code'],
        details: {},
        selected: true
      }
    ]
    this.selectionsForPromo = {
      selectedFacility: {
        facilityId: this.selectedFacilityId,
      },
      selectedPatient: {
        patientId: this.selectedPatient?.['uhid']
      }
    }
  }


  private processSlotList(availDays, facilityId) {
    // console.log('processSlotList', this.healthPkg, 'this.chosenFacility', this.chosenFacility);
    this.dates = availDays['dateList'];
    var payload = {};

    if (this.consultationSelections?.selectedPractitioner) {
      let visitType = this.consultationSelections.appointmentType === VIDEO ? VIDEO : HOSPITAL; 
      payload = {
        dates: this.dates,
        facilityId: this.chosenFacility?.facilityId,
        clinicCode: this.chosenFacility?.controls?.packageCalendarClinic,
        visitType: visitType,
        practitionerId: this.resourceId,
        resourceClass: this.resourceClass,
        resourceType: this.resourceClass,
        patientId: this.selectedPatient.uhid,
      }
    } else {
      let visitType: visitType = 'PACKAGE';
      if(this.healthPkg?.isBookingSubService) {
        visitType = this.healthPkg?.consultationType ?  this.healthPkg?.consultationType : 'PACKAGE';
      }
      payload = {
      practitionerId: this.resourceId, //this.selectedPractitioner?.id ? this.selectedPractitioner?.id : this.chosenFacility?.controls?.packageCalendarResourceCode,
      clinicCode: this.chosenFacility?.controls?.packageCalendarClinic,
      dates: this.dates,
      facilityId: facilityId,
      locale: this.user.getCurrentLanguage(),
      patientId: this.selectedPatient?.uhid,
      visitType: visitType,
      resourceClass: this.resourceClass,
      resourceType: this.resourceClass,
      isBackgroundProcess: false,
    }
    }

    // let payload = {"dates":["2025-05-16","2025-05-17","2025-05-18","2025-05-19","2025-05-20","2025-05-21","2025-05-22","2025-05-23","2025-05-24","2025-05-25","2025-05-26","2025-05-27","2025-05-28","2025-05-29","2025-05-30","2025-05-31"],"facilityId":"JA","clinicCode":"COHC","visitType":"PACKAGE","practitionerId":"HEALTHCHECK","resourceClass":"P","resourceType":"P","patientId":"JA00171233","locale":"en"}

    // console.log('getAvailabeSlots',payload)

    this.user.getSlotList(payload).subscribe(data => {
      // console.log('response---',data)
      let slotList = [{ facility: facilityId, slots: data.slots }];
      this.setSlotList(this.dates, slotList);  
    })   
  }


    public getAvailDaysList(date){
    let initDate = moment(date, DEFAULT_DATE_FORMAT);
    let finishDate = moment(date, DEFAULT_DATE_FORMAT).add(10, 'days');
    let dates = {
      startDate: date,
      endDate: finishDate.format(DEFAULT_DATE_FORMAT),
      dateList: [],
      availSlots:{},
      availPractitioners: [],
      practitionerDetails: {},
    }
    dates['clinicCode'] = this.chosenFacility?.controls?.packageCalendarClinic
    // if(this.practitionerList){
    //   dates['clinicCode']= this.practitionerList.clinicCode,
    //   dates['clinicName']= this.practitionerList.clinicName
    // }
    let i = 0;
    while (i < 7) {
      dates.dateList.push(initDate.format(DEFAULT_DATE_FORMAT));
      initDate = moment(initDate).add(1, 'day');
      i++;
    }
    return dates;
  }


  public openPicker() {
    this.dateRange.nativeElement.click();
  }
  public vaadinChange(event) {
    if (!event || !event['target'] || !event['target']['__data'] || !event['target']['__data'].value) return;
    let availDays = this.getAvailDaysList(event['target']['__data'].value);
    this.processSlotList(availDays, this.selectedFacilityId);
  }
  public changeActiveFacility(facility) {
    this.selectedFacility = facility;
    this.slotList = {
      dates: [],
      clinics: [],
      slots: {}
    };
    this.facilityId = facility['facilityId'];
    let availDays = this.getAvailDaysList(this.user.getMoment().format('YYYY-MM-DD'));
    this.processSlotList(availDays, this.selectedFacilityId);
  }
  private sortTime = (a, b) => {
    if (this.user.getMoment(a.time, 'HH:mm').isAfter(this.user.getMoment(b.time, 'HH:mm'))) {
      return 1;
    } else return -1
  }

  // private initAvailDates(date) {
  //     if (!date || date == '') return;
  //     if (Object.values(this.availDays).every(day => !day)) {
  //       this.toast.showToast(null, 'No_dates_are_configured_for_selected_practitioner.', TOAST_ERROR, true);
  //       return;
  //     }
  //     if (this.allowOnlyDays) {
  //       this.availDateList = this.allowOnlyDays;
  //     } else {
  //       let initDate = moment(date, 'YYYY-MM-DD');
  //       this.availDateList = [];
  //       while (this.availDateList.length !== 10) {
  //         if (this.availDays.indexOf(initDate.format('ddd').toLowerCase()) !== -1) {
  //           if (!this.toRestrictDays || !this.toRestrictDays.includes(initDate.clone().format('YYYY-MM-DD')))
  //             this.availDateList.push(initDate.format('YYYY-MM-DD'));
  //         }
  //         initDate = moment(initDate).add(1, 'day');
  //       }
  //     }
  //     if(this.visitType == 'PACKAGE'){
  //       this.getSlotsForSingleFacility(this.availDateList,  [{ facilityId: this.facilityId }]);
  //     }
  //     // this._input.in['practitioner']['facList']
  //   }

  // private getSlotsForSingleFacility(dates, facilityList){
  //   let promiseObj = facilityList.map(facility => {
  //     return new Promise((resolve, reject) => {
  //       this.user.getSlotList(this.practitionerId, facility.facilityId, dates, this.visitType, this.specialityId).subscribe(data => { 
  //         let resolveObj = { facility: facility.facilityId, slots: data.slots };
  //         resolve(resolveObj);
  //       }, _ => {
  //           let resolveObj = { facility: facility.facilityId, slots: {} };
  //           resolve(resolveObj)
  //       })
  //     })
  //   })
  //   Promise.all(promiseObj).then(slotList => {
  //     this.setSlotList(dates, slotList);
  //   })
  // }

  private setSlotList(dates, slotList) {

    let combinedList = slotList.reduce((comb, obj) => {
      Object.entries(obj['slots']).forEach(([dateKey, dateValue]) => {
        if (!comb[dateKey]) {
          comb[dateKey] = {}
        }
        Object.entries(dateValue).forEach(([clinicKey, clinicValue]) => {
          if (!comb[dateKey][clinicKey]) {
            comb[dateKey][clinicKey] = {};
          }
          comb[dateKey][clinicKey][obj['facility']] = clinicValue
        })
      })
      return comb;
    }, {})
    let clinicObj = {};
    let clinicList = [];
    let dateList = [];
    dates.forEach(d => {
      clinicObj = {
        ...clinicObj,
        [d]: {}
      }
    })
    this.startIndex = 0;
    this._startIndex = 0;
    this.endIndex = 3;
    this._endIndex = 6;
    Object.entries(combinedList).map(slot => {
      let date = slot[0];
      if (dateList.indexOf(date) == -1) {
        dateList.push(date);
      }
      let clinics = slot[1];
      Object.entries(clinics).map((clinic: any) => {
        let c = clinic[0];
        clinicList.push(c);
        Object.entries(clinic[1]).forEach(([facilityId, times]: any) => {
          let s = times.split(',');
          let noonstarttime = date + ' 13:00';
          let evestarttime = date + '16:30';
          let mrng = [];
          let noon = [];
          let eve = [];
          let facilityTimezone = this.user.getFacilityTimezone(facilityId);
          const directoffset = this.user.getDirectOffset(facilityId);
          let curDate = moment().tz(facilityTimezone).format('YYYY-MM-DD HH:mm');
          s.forEach(x => {
            let checkTime = date + ' ' + x;
            let checkTimeMoment = moment(checkTime, 'YYYY-MM-DD HH:mm').tz(facilityTimezone, true)
            if (date == moment().tz(facilityTimezone).format("YYYY-MM-DD")) {
              let momentVar = moment().tz(facilityTimezone).add(directoffset, 'hours');
              if (checkTimeMoment.isSameOrAfter(momentVar)) {
                // momentVar = this.user.getMoment().add(this.directoffset,'hours').format("HH:mm");
                let noondifftime = checkTimeMoment.diff(this.user.getMoment(noonstarttime, 'YYYY-MM-DD HH:mm'));
                let evedifftime = checkTimeMoment.diff(this.user.getMoment(evestarttime, 'YYYY-MM-DD HH:mm'));
                if (noondifftime < 0) {
                  mrng.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/Book_new/morning.svg' });
                } else if (evedifftime < 0) {
                  noon.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/Book_new/noon_.svg' });
                } else {
                  eve.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/Book_new/evening.svg' })
                }
              }
            }
            else if (checkTimeMoment.isSameOrAfter(this.user.getMoment(this.curDate, 'YYYY-MM-DD HH:mm'))) {
              let noondifftime = checkTimeMoment.diff(this.user.getMoment(noonstarttime, 'YYYY-MM-DD HH:mm'));
              let evedifftime = checkTimeMoment.diff(this.user.getMoment(evestarttime, 'YYYY-MM-DD HH:mm'));
              if (noondifftime < 0) {
                mrng.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/slot/morning.svg' });
              } else if (evedifftime < 0) {
                noon.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/slot/noon_.svg' });
              } else {
                eve.push({ clinic: c, facility: facilityId, time: x, '_icon': 'assets/icons/slot/evening.svg' })
              }
            }
          });
          if (clinicObj[date]) {
            mrng = mrng.sort(this.sortTime);
            noon = noon.sort(this.sortTime);
            eve = eve.sort(this.sortTime);
            clinicObj[date] = { mrng: mrng, noon: noon, eve: eve };
          }
        })
      })
    });
    this.changeActiveClinic(clinicList[0]);
    this.slotList = {
      dates: dates,
      clinics: clinicList,
      slots: clinicObj
    }
    // console.log(this.slotList);
    this.selectedDate = this.slotList.dates[0];
    this.slotList.dates.forEach(element => {
      if ((_.isEmpty(this.slotList['slots'][element])) || (this.slotList['slots'][element]['mrng'].length == 0 &&
        this.slotList['slots'][element]['noon'].length == 0 && this.slotList['slots'][element]['eve'].length == 0)) {
        this.noslot = true;
        this.slotList['slots'][element] = {};
      }
    });
    this.selectedSlots = [
      ...this.slotList['slots'][this.selectedDate]['mrng'],
      ...this.slotList['slots'][this.selectedDate]['noon'],
      ...this.slotList['slots'][this.selectedDate]['eve']
    ];
    // this.selectedSlot = this.selectedSlots[0];
  }

  public changeActiveClinic(clinicCode) {
    this.selectedClinic = clinicCode;
  }

    public changeStart(count) {
    if ((this.startIndex <= 0 && count < 0) || (this.endIndex >= this.slotList.dates.length && count > 0)) {
      return;
    } else {
      this.startIndex += count;
      this.endIndex += count;
    }
  }

  public _changeStart(count) {
    if ((this._startIndex <= 0 && count < 0) || (this._endIndex >= this.slotList.dates.length && count > 0)) {
      return;
    } else {
      this._startIndex += count;
      this._endIndex += count;
    }
  }

    public completeSelection(date: any, slot: any) {
    this.selectedDate = date;
    let obj = {
      name: this.user.getMoment(date).format('DD MMM YYYY,') + this.user.getMoment(slot['time'], 'HH:mm').format('hh:mm a'),
      date: date,
      slot: slot['time'],
      clinicCode: slot['clinic']
    }
    this.selectedSlot = obj
    let selectedFacility= this.user.findFacility(slot['facility']);
    let fobj = {
      id: selectedFacility['facilityId'],
      name: selectedFacility['facilityName'],
      address: selectedFacility['facilityAddress']
    }
    this.setSlot({ slot: obj, facility: fobj })
    // }
  }

  public async setSlot(event) {
    this.healthPkg = this.packageService.getAllHpValues();
    this.slotEvent = event;
    // console.log('setSlot', event, event.slot, 'healthPkg', this.healthPkg);
    this.packageService.setValue('selectedSlot', event.slot);
    this.packageService.setValue('selectedFacility', event.facility);
    this.packageService.setValue('computedDetail', null);
    if(!this.healthPkg?.isBookingSubService) {
      // console.log('this.bookingForConcepts', this.bookingForConcepts);
      let careElementType = this.bookingForConcepts[0]?.careElementType;
      let { navState, consultationType } = await this.generateNavState(careElementType);
      this.packageService.setValue('consultationType', consultationType);
      this.packageService.setValue('careElementType', careElementType);
      this.packageService.setValue('careElementParams', navState.careElementParams);
      if (careElementType === 'CON') {
        let applicableSpecialities = this.choosenFacility?.controls?.applicableSpecialities;
        // if (!applicableSpecialities || (Array.isArray(applicableSpecialities) && applicableSpecialities.length === 0)) {
        //   this.handleResourceBasedNavigation(navState);
        //   return;
        // }
        let facilityId = this.choosenFacility?.facilityId;
        let facilityForConsultation = null;
        if (facilityId) {
          facilityForConsultation = this.user.getFacilityByFacilityId(facilityId)
        }
      }
    }
    this.previewProcess()
  }

    private async generateNavState(careElementType) {
    let consultationType;
    if (careElementType === 'CON') {
      consultationType = await this.getConsultationType()
      if (!consultationType) return;
    }
    let navState = {
      selectedDirective: this.selectedDirective,
      selectedPackage: this.selectedPackage,
      selectedFacilityId: this.selectedFacilityId,
      choosenFacility: this.choosenFacility,
      selectedPatient: this.selectedPatient,
      bookingForConcepts: this.bookingForConcepts,
      selectedVisitType: this.selectedVisitType,
      packageIndicator: this.packageIndicator,
      bookingApplicableFacilities: this.bookingApplicableFacilities,
      careElementParams: {
        careElementType: careElementType,
        consultationType: consultationType
      },
      packageDefination: this.packageDefination
    }
    // console.info('gennavState', this.bookingForConcepts)
    return { navState, consultationType }
  }

    private async getConsultationType() {
    let consultationType = this.getMappedConsultationType();
    if (consultationType === 'ALL' && this.bookingForConcepts[0]?.careElementType === 'CON') {
      consultationType = await this.chooseConsultationType()
    }
    return consultationType;
  }

    private getMappedConsultationType() {
    let defaultConsultationType = this.selectedVisitType === 'CLINIC' ? 'HOSPITAL' : 'VIDEO';
    let keyNameForConsultationType = this.selectedVisitType === 'CLINIC' ? 'clinicConsultTypecode' : 'homecareConsultTypecode';
    let consultationType = ['HOSPITAL', 'VIDEO', "ALL"].includes(this.healthPkg?.firstService?.[keyNameForConsultationType]) ? this.healthPkg?.firstService[keyNameForConsultationType] : defaultConsultationType;
    return consultationType
  }

  public chooseConsultationType(): Promise<string | null> {
    this.openConsultationTypeSelection = true;

    return new Promise((resolve) => {
      this.consultResolve = resolve;
    });
  }

  public handleClose() {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(null);
  }

  public handleConfirm(consultType: string) {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(consultType);
  }



  public previewProcess() {
    if (this.isBookingSubService) {
      this.canPay = false;
      this.proceedApptFlow();
      return;
    }
    if (!this.isReschedule) {
      if (this._input['modeOfService'] === 'CLINIC' || this.healthPkg?.modeOfService === 'CLINIC') {
        this.getPackageCharges()
      } else {
        // this.getHomecareCharges()
      }
    } else {
      this.proceedApptFlow();
    }
  }

  private getPackageCharges(forcePaymentWithCash: boolean = false) {
    let payload = {
      patientId: this.healthPkg.selectedPatient.uhid,
      facilityId: this.healthPkg.choosenFacility.facilityId,
      patientClass: 'EX',
      orderCatalogCode: this.healthPkg.selectedPackage.code,
      subServiceOrderCatalogCode: this.healthPkg.bookingForConcepts[0].code,
      locale: 'en',
      billingGroupId: null,
      insuranceFinDtls: null,
      // additional params
      clinicCode: this.selectedSlot.clinicCode,
      date: this.selectedSlot.date,
      time: this.selectedSlot.slot,
      patientPersonId: this.healthPkg.selectedPatient.personid,
      personName: this.healthPkg.selectedPatient.personname,
      dob: moment(this.healthPkg.selectedPatient.dob).format('YYYY-MM-DD'),
      gender: this.healthPkg.selectedPatient.gender || 'M',
      patientName: this.healthPkg.selectedPatient.personname,
      resourceId: this.resourceId,
      practitionerId: this.healthPkg.selectedPract ? this.resourceId: null,
      resourceClass: this.resourceClass,
      resourceType: this.resourceClass,
      forcePaymentWithCash: forcePaymentWithCash,
      directiveCode: this.healthPkg.selectedDirective?.code || "HLTHPKGS",
      conceptCode: this.selectedPackage?.code,
      subserviceDirectiveCode: this.healthPkg.bookingForConcepts[0]?._directiveRef?.code,
      subServiceConceptCode: this.healthPkg.bookingForConcepts[0].code,
    }
    let subscribers = [this.packageService.getPackageCharges(payload)]
    // if (this.selectedVisitType === 'HOMECARE') {
    //   let addChargePayload = this.generateAddlChargeParams();
    //   subscribers.push(this.homecare.getHomeCareAddServiceCharge(addChargePayload));
    // }
    forkJoin(subscribers).subscribe((response) => {
      let data = response[0];
      let addChargeResponse;
      // if (response[1]) {
      //   addChargeResponse = response[1];
      //   this.homeCareAddlCharge = {
      //     name: addChargeResponse.homeCareAdditionalServiceChargeDesc,
      //     code: addChargeResponse.homeCareAdditionalServiceChargeCode,
      //     value: Number(addChargeResponse.homeCareAdditionalServiceCharge)
      //   }
      // }
      this.mapServiceResponse(data);
    })
  }
  private mapServiceResponse(data) {
    let totalPatientPayable = this.user.fixDecimalPlaces(Number(data.patientPayableAmount));
    let chargeArr = data.charge;
    let applicableService: any = data.discount;
    let discountApplicableService = applicableService.filter(service => {
      return service?.discountApplicable === 'Y'
    });

    let promoApplicableService = applicableService.filter(service => {
      return service?.promoDiscountApplicable === 'Y'
    });
    let pointsApplicableService = applicableService.filter(service => {
      return service?.pointsDiscountApplicable === 'Y'
    });

    const checkDiscountType = (services, code) => {
      return services.map(service => service.code).includes(code)
    }

    this.selectedPackage['discountApplicable'] = checkDiscountType(discountApplicableService, this.selectedPackage['code'])
    this.selectedPackage['promoDiscountApplicable'] = checkDiscountType(promoApplicableService, this.selectedPackage['code'])
    this.selectedPackage['pointsDiscountApplicable'] = checkDiscountType(pointsApplicableService, this.selectedPackage['code'])
    let concept = chargeArr.find((d) => d.code == this.selectedPackage['code']);
    this.selectedPackage['chargeStr'] = concept['chargeStr'];
    this.selectedPackage['servicecost'] = totalPatientPayable;
    this.selectedServices[0]['details']['discountApplicable'] = this.selectedPackage['discountApplicable'] ? 'Y': 'N';
    this.selectedServices[0]['details']['promoDiscountApplicable'] = this.selectedPackage['promoDiscountApplicable'];
    this.selectedServices[0]['details']['pointsDiscountApplicable'] = this.selectedPackage['pointsDiscountApplicable'];
    this.selectedServices[0]['details']['chargeStr'] = concept ? concept['chargeStr'] : '';
    this.selectedServices[0]['details']['servicecost'] = totalPatientPayable;
    this.selections = {
      facility: { id: this.selectedFacilityId, },
      practitioner: { id: this.resourceId },
      patient: { id: this.selectedPatient?.['uhid'] }
    }
    this.packageService.setValue('selections', this.selections);
    this.packageService.setValue('selectedServicesDtl', this.selectedServices);
    if (data['disableCoupon']) {
      let isEnableCoupon = false;
      this.packageService.setValue('isEnableCoupon', isEnableCoupon)
    }
    if (data['disablePoints'] || !this.selectedPackage['pointsDiscountApplicable']) {
      let isEnablePoints = false
      this.packageService.setValue('isEnablePoints', isEnablePoints)
    }
    if (data['disablePromo'] || !this.selectedPackage['promoDiscountApplicable']) {
      let isEnablePromo = false;
      this.packageService.setValue('isEnablePromo', isEnablePromo)
    }
    let additionalCharge = Number(0)
    let parsedCharges = chargeArr.map(charge => charge.parsedCharge)
    this.chargeVatInfo = _.cloneDeep(data.parsedCharges);
    if (parsedCharges && parsedCharges.length > 0) {
      this.chargeVatDetails = this.calculateVatcharges(data.parsedCharges)
      this.packageService.setValue('chargeVatDetails', this.chargeVatDetails)
    }
    this.chargeDetails = {
      discountDetails: { applicable: this.selectedPackage['promoDiscountApplicable'] || this.selectedPackage['pointsDiscountApplicable'], charge: concept['chargeStr'] },
      baseServiceCharge: this.chargeVatDetails.baseServiceAmount,
      vatAmount: this.chargeVatDetails.vatAmount,
      vatExemptAmount: this.chargeVatDetails.vatExemptAmount,
      consultationCharge: totalPatientPayable,
      totalAmount: totalPatientPayable,
      discountedPayable: totalPatientPayable,
      netPayable: totalPatientPayable,
      promoDiscount: 0,
      couponDiscount: 0,
      isPromoApplied: false,
      isCouponApplied: false,
      isFreeFollowUp: false,
      couponTitle: [],
      canPayOptional: false,
      additionalCharge: additionalCharge,
    }
    this.computedDetail = this.getComputedCodeDetail()
    this.packageService.setValue('computedDetail', this.computedDetail);
    this.calculatePayable()
    this.proceedApptFlow()

    setTimeout(_ => {
      // console.log('can pay....', this.canPay);
    }, 500)
    // this.isApplyingCode = false;
    this.cdf.detectChanges();
  }

  public getComputedCodeDetail() {
    let computedDetail = {
      loading: false,
      //charge always equals patientPayable
      charge: this.chargeDetails.netPayable,
      patientPayable: this.chargeDetails.netPayable,
      //charge always equals patientPayable
      discountedPayable: this.chargeDetails?.discountedPayable,
      freeFollowUp: this.chargeDetails?.isFreeFollowUp ? 'Y' : 'N',
      billingGroupCode: 'CASH',
      paid: false,
      additionalChargeDetails: {
          actualCharge: this.chargeDetails?.['consultationCharge'],
          totalCharge: this.chargeDetails?.['totalAmount'],
          payableCharge: this.chargeDetails?.['netPayable'],
          homeCareAdditionalCharge: this.homeCareAddlCharge?.['value'] || 0
      },
      promoDetails: this.chargeDetails?.discountDetails,
      promoCodeParams: {
        selectedPractitioner: this.resourceId,
        selectedSpeciality: this.selections?.selectedPractitioner?.specialityId,
        selectedFacility: {
          facilityId: this.selectedFacilityId
        },
        selectedPatient: {
          patientId: this.selectedPatient['uhid']
        }
      },
      chargeVatDetails: this.chargeVatDetails,

      coupon_or_discount: {
      netPayable:  this.chargeDetails.netPayable,
      discountedPayable:  this.chargeDetails.netPayable
      },
      isPromoApplied: false,
      isPointsApplied: false,
      isCouponApplied: false,
      display: {
        cc: this.chargeVatDetails?.baseServiceAmount,
        vat: this.chargeDetails?.vatExemptAmount  ? 0 :  this.chargeVatDetails?.vatAmount,
        promo: this.chargeDetails?.promoDiscount || 0,
        points: this.chargeDetails?.pointsDiscount || 0,
        coupon: this.chargeDetails?.couponDiscount || 0,
        discountApplied: (this.chargeDetails?.promoDiscount || this.chargeDetails?.pointsDiscount)  ? 'Y':  'N',
        discountedPayable: Number(this.chargeDetails?.discountedPayable),
        payable: this.chargeDetails?.netPayable,
        homeCareAdditionalCharge: this.homeCareAddlCharge?.['value'] || 0
      }
    }
    return computedDetail
  }

    public proceedApptFlow() {
    this.packageConfirmView = true;
    console.info('canpay', this.canPay, 'chargeDetails', this.chargeDetails, 'packageConfirmView', this.packageConfirmView, )
    this.packageService.setValue('chargeDetails', this.chargeDetails)
    this.packageService.setValue('packageConfirmView', this.packageConfirmView)
    this.packageService.setValue('packageOnlyFlow', this.packageOnlyFlow);
    this.packageService.setValue('canPay', this.canPay);
    // console.log('health pkg>>>>>', this.healthPkg, this.packageService.getAllHpValues());
    if(this.flowType === 'HEALTHPKG') {
      this.complete.emit(this.slotEvent);
    }
  }

  private calculatePayable() {
    let couponDiscount = this.chargeDetails.couponDiscount || 0;
    let pointsDiscount = this.pointsType == 'PAYMENT' ? (this.chargeDetails.pointsDiscount || 0) : 0;
    let additionalCharge = Number(this.chargeDetails.additionalCharge) || 0
    this.chargeDetails.netPayable = this.chargeDetails.discountedPayable + additionalCharge - couponDiscount - pointsDiscount;
    this.chargeDetails.totalVat = this.calculateVatDisplayAmount(this.chargeDetails.vatAmount, this.chargeDetails.vatExemptAmount)
    this.chargeDetails._payableWithoutCoupon = this.chargeDetails.netPayable + couponDiscount;
    this.chargeDetails._payableWithoutPoints = this.chargeDetails.netPayable + pointsDiscount;
    this.resetPaymentFlow()
  }

    private resetPaymentFlow() {
    let canPay = true;
    if (Number(this.chargeDetails.netPayable) <= 0) {
      this.chargeDetails.netPayable = 0;
      canPay = false;
    }
    this.canPay = this.isPayableService && canPay;
    this.chargeDetails.netPayable = this.user.fixDecimalPlaces(Number(this.chargeDetails.netPayable));
    this.chargeDetails.yetToPay = Number(this.chargeDetails.netPayable) > 0
    this.chargeDetails = _.cloneDeep(this.chargeDetails)
    setTimeout(_ => {
      this.cdf.detectChanges()

    }, 500)
  }

  private getPageConfiguration() {
    this.isPayableService = false;
    let patientPayable = this.chosenFacility?.controls?.discountCharge || this.chosenFacility?.controls?.charge || null
    // if (this.selectedVisitType === 'CLINIC' && this.packageIndicator === 'ORDERSET') {
      // if (this.user.getPaymentGateway && this.user.canPayForService('serviceswithorder') && this.chosenFacility?.controls?.payableOnline === 'true') {
        this.isPayableService = true;
      // }
    // } else {
      // this.isPayableService = true;
    // }
    if (!this.isPayableService) {
      this.patientPayableApprox = patientPayable;
    }
    this.couponAdditionalParams = {
      package: this.selectedPackage,
      patient: this.selectedPatient,
      isPackage: true,
    }
    // console.log('couponAdditionalParams',this.couponAdditionalParams)
  }

    private calculateVatcharges(parsedCharges) {
    let baseAmount = 0, vatAmount = 0, vatExemptAmount = 0;
    parsedCharges.forEach(charge => {
      baseAmount = baseAmount + parseFloat(charge.baseServiceAmount);
      vatAmount = vatAmount + (charge.vatAmount ? parseFloat(charge.vatAmount) : 0);
      vatExemptAmount = vatExemptAmount + (charge.vatExemptedAmt ? parseFloat(charge.vatExemptedAmt) : 0);
    })
    const chargeVatDetails = {
      baseServiceAmount: baseAmount,
      vatAmount: vatAmount,
      vatExemptAmount: vatExemptAmount
    }
    chargeVatDetails['vatDisplayAmount'] = this.calculateVatDisplayAmount(chargeVatDetails.vatAmount, chargeVatDetails.vatExemptAmount);
    return chargeVatDetails
  }
  private calculateVatDisplayAmount(vatamt, vatexpamt) {
    let vatDisplayAmount;
    vatDisplayAmount = vatamt - vatexpamt;
    vatDisplayAmount = vatDisplayAmount.toString();
    return vatDisplayAmount;
  }
    get resourceId() {
    //return this.consultationSelections?.selectedPractitioner || this.chosenFacility?.controls?.packageCalendarResourceCode || this.chosenFacility?.clinicCode
    let resourceId=''
    if(this.healthPkg.selectedPract?.id){
      resourceId=this.healthPkg.selectedPract?.id
    }else if(this.healthPkg.choosenFacility?.controls?.packageCalendarResourceCode){
      // console.info('this.choosenFacility.controls.packageCalendarResourceCode',this.choosenFacility.controls.packageCalendarResourceCode,this.rescheduleParams)
      let resources = this.healthPkg.choosenFacility.controls.packageCalendarResourceCode.split(',')
      if(resources.length==1)
      resourceId=resources[0] || this.healthPkg.choosenFacility.controls.packageCalendarResourceCode;
      else if(resources.length>1){
        resourceId=resources[0]
        if(this.healthPkg.rescheduleParams?.resourceId && resources.includes(this.healthPkg.rescheduleParams.resourceId)){
          resourceId=this.healthPkg.rescheduleParams.resourceId
        }
      }
    }else if(this.healthPkg.choosenFacility?.clinicCode){
      resourceId=this.healthPkg.choosenFacility.clinicCode
    }
    // console.log('resourceId<<<<<<<', resourceId)
    return resourceId
  }
  get resourceClass() {
    // console.log('resou/rceClass<<<<<<<', this.healthPkg.choosenFacility)
    return this.healthPkg.selectedPract ? null : (this.healthPkg.choosenFacility?.controls?.packageCalendarResourceClass || this.healthPkg.choosenFacility?.resourceType)
  }


}
